type LivestreamMetricsProps = {
  milestoneName: string;
  eventTimestamp: string;
  userId: number;
  locationId: number;
  monitoringSpecialistId: number;
  cameraUuid: string;
  cameraModel: string;
  cameraFwVersion: string;
  rawRtcStatsReport: Record<string, unknown>;
  reasonCode?: string;
  reasonDescription?: string;
};

export const useLivestreamMetrics = () => {
  const sendMetric = ({
    milestoneName,
    eventTimestamp,
    userId,
    locationId,
    monitoringSpecialistId,
    cameraUuid,
    cameraModel,
    cameraFwVersion,
    rawRtcStatsReport,
    reasonCode,
    reasonDescription,
  }: LivestreamMetricsProps) => {
    return fetch(
      `${process.env.REACT_APP_MONITORING_METRICS_URL}/v1/metrics/livestream`,
      {
        method: 'POST',
        body: JSON.stringify([
          {
            milestoneName,
            eventTimestamp,
            userId,
            locationId,
            monitoringSpecialistId,
            cameraUuid,
            cameraModel,
            cameraFwVersion,
            rawRtcStatsReport,
            reasonCode,
            reasonDescription,
          },
        ]),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        keepalive: true,
      }
    );
  };

  return {
    sendMetric,
  };
};
